import React, { type FC } from "react";
import { type AssessmentsNoResultsProps } from "../types";
import NoSearchResults from "../../../../components/noSearchResults";
import NoResultsWithButton from "components/noResultsWithButton/NoResultsWithButton";

import styles from "./assessmentsNoResults.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListOl } from "@fortawesome/pro-solid-svg-icons";

const noAssessmentsCreated = (
  createButton: React.ReactElement | null | undefined,
  title?: string,
  description?: string,
): React.ReactElement => {
  return (
    <NoResultsWithButton
      title={title || "You don't have any assessments"}
      description={description || "Looks like you don't have any assessments yet."}
      icon={<FontAwesomeIcon icon={faListOl} className={styles.assessmentsNoResultsIcon} />}
      actionButton={createButton}
      actionText={createButton ? "Add some using the button below." : undefined}
      filtered={false}
    />
  );
};

const AssessmentsNoResults: FC<AssessmentsNoResultsProps> = ({
  createButton,
  filtered,
  title,
  description,
}): React.ReactElement => {
  return filtered ? <NoSearchResults /> : noAssessmentsCreated(createButton, title, description);
};

export default AssessmentsNoResults;
